import React, { useContext } from 'react';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import AuthContext from '../context/auth/authContext';

const NotAllowed = () => {
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const handleClick = () => {
    let path = '/';
    if (user) {
      console.log(user.role)
      switch (user.role) {
        case 'sky-customer': path = '/users'; break;
        case 'sky-customer-advanced': path = '/users'; break;
        case 'sky-billing-file': path = '/reporting'; break;
        case 'sky-maintenance': path = '/maintenance'; break;
        default: path = '/content/overview';
      }
    }
    history.push(path);
  };

  return (
    <div>
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you don't have permission to view this page"
        extra={
          <Button onClick={handleClick} type="primary">
            Back Home
          </Button>
        }
      />
      ,
    </div>
  );
};

export default NotAllowed;
